import React from 'react';
import './InternationalImage.css';



const InternationalImage = () => {
  return (
    <>
    <div className="international-image-section"> </div>
    
   </>
  );
};


export default InternationalImage;
